import api from "@/config/api"

export default {
  namespaced: true,
  state: () => ({
    highRiskCount: 0
  }),
  mutations: {
    setHighRiskCount(state, count) {
      state.highRiskCount = count
    }
  },
  actions: {
    async fetchHighRiskCount(context) {
      try {
        const response = await api.get("burnout_scores/high_risk_count")
        context.commit("setHighRiskCount", response.data.count ?? 0)
      } catch (error) {
        // фича может быть недоступна (нет burnout) — молча оставляем 0
        context.commit("setHighRiskCount", 0)
      }
    }
  }
}
